import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { NAV_ITEMS } from '../../utils/constants';
import authService from '../../services/authService';
import Icon from '../common/Icon';
import { getBrandConfig } from '../../utils/branding';
import './Sidebar.css';

const Sidebar = ({ onToggle }) => {
    const location = useLocation();
    const isAdmin = authService.isAdmin();
    const brand = getBrandConfig();
    const [isCollapsed, setIsCollapsed] = useState(true);

    const visibleNavItems = NAV_ITEMS.filter(item => {
        if (item.adminOnly) {
            return isAdmin;
        }
        return true;
    });

    const toggleSidebar = () => {
        const newState = !isCollapsed;
        setIsCollapsed(newState);
        if (onToggle) {
            onToggle(newState);
        }
    };

    return (
        <aside className={`sidebar ${isCollapsed ? 'sidebar-collapsed' : ''}`}>
            <div className="sidebar-header">
                <button 
                    className="sidebar-toggle" 
                    onClick={toggleSidebar}
                    aria-label={isCollapsed ? "Ouvrir le menu" : "Fermer le menu"}
                >
                    <Icon name={isCollapsed ? "ChevronRight" : "ChevronLeft"} size={20} />
                </button>
                {!isCollapsed && (
                    <div className="logo">
                        {brand.isJvweb && brand.logoPath ? (
                            <img src={brand.logoPath} alt={brand.name} className="logo-img" />
                        ) : (
                            <span className="logo-text">{brand.name}</span>
                        )}
                    </div>
                )}
            </div>

            <nav className="sidebar-nav">
                <ul className="nav-list">
                    {visibleNavItems.map((item) => {
                        const isActive = location.pathname === item.path;
                        return (
                            <li key={item.id} className="nav-item">
                                <Link
                                    to={item.path}
                                    className={`nav-link ${isActive ? 'nav-link-active' : ''}`}
                                    title={isCollapsed ? item.label : ''}
                                >
                                    <Icon name={item.icon} size={20} />
                                    {!isCollapsed && <span>{item.label}</span>}
                                </Link>
                            </li>
                        );
                    })}
                </ul>
            </nav>
        </aside>
    );
};

export default Sidebar;
